import styles from './NavBarTablet.scss';

import cx from 'classnames';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { NavigationItem } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ButtonLinkV2 } from 'src/components/Button/ButtonLinkV2';
import { ContentLinkV2 } from 'src/components/ContentLinkV2/ContentLinkV2';
import { MenuButton } from 'src/components/MenuButton/MenuButton';
import { FlatEntry } from 'src/services/cms/flattenContentful';
import { componentKeyV2 } from 'src/utils/ComponentKeyV2';

import { CartLink } from '../CartLink/CartLink';
import { logo } from '../NavBarV2';
import { NavDrawer } from '../NavDrawer/NavDrawer';
import { NavMenuDrawer } from '../NavMenuDrawer/NavMenuDrawer';
import { UiController } from '../UseUiController';

export interface NavBarTabletProps extends UiController {
  buttonUtilItems: Array<FlatEntry<NavigationItem>>;
  menuItems: Array<FlatEntry<NavigationItem>>;
  textUtilItems: Array<FlatEntry<NavigationItem>>;
  materialIconUtilItems: Array<FlatEntry<NavigationItem>>;
}

export const NavBarTablet: FC<NavBarTabletProps> = ({
  activeMenuIndex,
  buttonUtilItems,
  materialIconUtilItems,
  isDrawerOpen,
  isSubNavDrawerOpen,
  menuItems,
  textUtilItems,
  closeDrawer,
  closeSubNavDrawer,
  openMenuDrawer,
  openSubNavDrawer,
}) => {
  const { t } = useTranslation();

  const hasNavDrawer = !!menuItems.length || !!textUtilItems.length;

  return (
    <div className={styles.navBarTabletMenu}>
      <nav className={styles.navBarTabletMenuLeft} aria-label={t('navigation-header.left-menu')}>
        {hasNavDrawer && (
          <>
            <MenuButton
              onClick={isDrawerOpen ? closeDrawer : openMenuDrawer}
              isOpen={isDrawerOpen}
              className={styles.navBarTabletMainMenuButton}
            />
            <div className={styles.navBarTabletMenuDrawer}>
              <NavDrawer
                titleEntry={menuItems[activeMenuIndex]}
                defaultTitle={t('main-menu')}
                isOpen={isDrawerOpen}
                onClickCloseButton={isSubNavDrawerOpen ? closeSubNavDrawer : undefined}
              >
                <NavMenuDrawer
                  {...{ activeMenuIndex, menuItems, textUtilItems, openSubNavDrawer }}
                  isDrawerClose={!isDrawerOpen}
                  closeDrawer={closeDrawer}
                />
              </NavDrawer>
            </div>
          </>
        )}
        {logo}
      </nav>
      <nav className={styles.navBarTabletMenuRight} aria-label={t('navigation-header.right-menu')}>
        {materialIconUtilItems.map((item, index) => (
          <ContentLinkV2
            key={componentKeyV2(item, index)}
            entry={item}
            variant="nav"
            className={cx('material-icon-as-text', styles.navBarTabletUtilMenu)}
          />
        ))}
        {buttonUtilItems.map((item, index) => (
          <ButtonLinkV2
            key={componentKeyV2(item, index)}
            entry={item}
            className={styles.navBarTabletUtilMenu}
          />
        ))}
        <CartLink />
      </nav>
    </div>
  );
};

NavBarTablet.displayName = 'NavBarTablet';
